import React, { useRef } from 'react';

interface CompanyLogoUploadProps {
  logoPreview: string | null;
  logoFile: File | null;
  uploadingLogo: boolean;
  initialData: any;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  handleLogoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleLogoUpload: () => void;
  setLogoPreview: (url: string | null) => void;
  setLogoFile: (file: File | null) => void;
  setFormData: (updater: (prev: any) => any) => void;
}

export const CompanyLogoUpload: React.FC<CompanyLogoUploadProps> = ({
  logoPreview,
  logoFile,
  uploadingLogo,
  initialData,
  fileInputRef,
  handleLogoChange,
  handleLogoUpload,
  setLogoPreview,
  setLogoFile,
  setFormData
}) => {
  return (
    <div className="form-section">
      <h3>Company Logo</h3>
      <div className="logo-upload-section" style={{ marginBottom: '20px' }}>
        {logoPreview && (
          <div className="logo-preview" style={{ marginBottom: '15px' }}>
            <img 
              src={logoPreview} 
              alt="Company logo preview" 
              style={{
                maxWidth: '200px', 
                maxHeight: '100px', 
                border: '1px solid var(--color-neutral-light-gray)',
                padding: '10px',
                borderRadius: '4px',
                boxShadow: 'var(--shadow-sm)',
                backgroundColor: 'var(--color-bg-white)'
              }} 
            />
          </div>
        )}
        <div className="logo-upload-controls">
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/jpg,image/png,image/gif,image/svg+xml"
            onChange={handleLogoChange}
            style={{ display: 'none' }}
          />
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => fileInputRef.current?.click()}
            style={{
              marginRight: '10px',
              backgroundColor: 'var(--color-neutral-light-gray)',
              color: 'var(--color-neutral-graphite)',
              border: '1px solid var(--color-neutral-light-gray)',
              borderRadius: '4px',
              padding: '8px 16px',
              fontFamily: 'var(--font-body)',
              transition: 'var(--transition-fast)',
              cursor: 'pointer'
            }}
          >
            {logoPreview ? 'Change Logo' : 'Upload Logo'}
          </button>
          {logoFile && initialData && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleLogoUpload}
              disabled={uploadingLogo}
              style={{
                backgroundColor: 'var(--color-primary-blue)',
                color: 'var(--color-neutral-white)',
                border: '1px solid var(--color-primary-blue)',
                borderRadius: '4px',
                padding: '8px 16px',
                fontFamily: 'var(--font-body)',
                transition: 'var(--transition-fast)',
                cursor: uploadingLogo ? 'not-allowed' : 'pointer',
                opacity: uploadingLogo ? 0.6 : 1
              }}
            >
              {uploadingLogo ? 'Uploading...' : 'Save Logo'}
            </button>
          )}
          {logoPreview && (
            <button
              type="button"
              className="btn btn-link"
              onClick={() => {
                setLogoPreview('/eclogo-check.svg');
                setLogoFile(null);
                setFormData(prev => ({ ...prev, logo_url: '/eclogo-check.svg' }));
              }}
              style={{
                marginLeft: '10px',
                backgroundColor: 'transparent',
                color: 'var(--color-primary-blue)',
                border: 'none',
                borderRadius: '4px',
                padding: '8px 16px',
                fontFamily: 'var(--font-body)',
                transition: 'var(--transition-fast)',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              Reset to Default Logo
            </button>
          )}
        </div>
        <p style={{ fontSize: '0.9em', color: 'var(--color-neutral-graphite)', marginTop: '10px' }}>
          Upload your company logo (JPEG, PNG, GIF, or SVG, max 5MB). This will be displayed on invoices and other documents.
        </p>
      </div>
    </div>
  );
};